<div class="container-fluid">

  <ul>
    <li class="fi-logo">
      <a href="http://www.failteireland.ie" target="_blank" aria-label="Fáilte Ireland Logo">
        <!-- <span class="icon-logo" matTooltip="Fáilte Ireland Website"></span> -->
        <img src="https://cdn.failteireland.ie/brandsassets/logos/FI_Mark_RGB_Primary_White.png"
          alt="Fáilte Ireland Logo" matTooltip="Fáilte Ireland Website" />
      </a>
    </li>
    <li class="di-logo">
      <a href="https://www.discoverireland.ie" target="_blank" aria-label="Discover Ireland Logo">
        <img src="https://cdn.failteireland.ie/brandsassets/logos/DiscoverIreland_Master_RGB_Linear_White.png"
          alt="Discover Ireland Logo" matTooltip="Discover Ireland Website" />
      </a>
    </li>
  </ul>
  <br />
  <p class="browser-note"><b>Note:</b> It is recommended to visit this portal using Microsoft Edge (version 2 or
    higher), Chrome (latest) and Firefox (latest) browsers for users using Windows and Android devices, or Safari
    browser (version 11 or higher) for users using Apple devices.</p>

  <p class="disclaimer">
    <strong>Disclaimer: </strong> Please note that all events are subject to approval and Fáilte Ireland reserves the
    right to edit any submitted event information to enure consistency of style and tone.
  </p>

  <ul>
    <li>
      <a href="https://www.visitdublin.com" target="_blank" aria-label="Visit Dublin Logo"><img
          src="https://cdn.failteireland.ie/brandsassets/logos/VD_White.png" alt="Visit Dublin Logo"
          matTooltip="Visit Dublin Website" /></a>
    </li>
    <li>
      <a href="https://www.irelandsancienteast.com" target="_blank" aria-label="Ireland's Ancient East Logo"><img
          src="https://cdn.failteireland.ie/brandsassets/logos/IAE_White.png" alt="Ireland's Ancient East Logo"
          matTooltip="Ireland's Ancient East Website" /></a>
    </li>
    <li>
      <a href="https://www.wildatlanticway.com" target="_blank" aria-label="Wild Atlantic Way Logo"><img
          src="https://cdn.failteireland.ie/brandsassets/logos/WAW_White.png" alt="Wild Atlantic Way Logo"
          matTooltip="Wild Atlantic Way Website" /></a>
    </li>
    <li>
      <a href="https://irelandshiddenheartlands.discoverireland.ie/" target="_blank"
        aria-label="Ireland's Hidden Heartlands Logo"><img
          src="https://cdn.failteireland.ie/brandsassets/logos/IHH_White.png" alt="Ireland's Hidden Heartlands Logo"
          matTooltip="Ireland's Hidden Heartlands Website" /></a>
    </li>
  </ul>

  <br /><br />
  <a class="privacy-policy" href="https://www.failteireland.ie/en/info/privacy" target="_blank"
    aria-label="Fáilte Ireland's Privacy Policy" matTooltip="Fáilte Ireland's Privacy Policy">Privacy Policy</a>
  <p class="last-updated" *ngIf="lastUpdated">Last updated: {{lastUpdated}}</p>
</div>